// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bar {\n  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);\n  background-color: #fff;\n  box-sizing: border-box;\n  min-height: 45px;\n  padding: 8px 10px;\n  position: fixed;\n  transition: all 0.5s ease;\n  width: auto;\n  z-index: 100;\n}\n", ""]);
// Exports
module.exports = exports;
